import { ContentId } from './content-block';
import { FUNCTIONAL_ELEMENT_TYPE, FunctionalElement } from './functional-element';

export type ValueFunctionalElement = Readonly<{
    id: ContentId;
    xmlId: string;
    label: string;
    value: string;
    type: FUNCTIONAL_ELEMENT_TYPE.VALUE | FUNCTIONAL_ELEMENT_TYPE.VALUE_UNIT;
    disabledNACheckbox: boolean;
    lowerLimit?: number; // cosima only
    upperLimit?: number; // cosima only
    valueXmlId?: string; // cosima only
    expectedValueText?: string; // cosima only
    unit?: string; // cosima only
    description?: string; // only used in cosima
    function?: string; // only used in cosima
}> &
    FunctionalElement;

export const initialValueState: ValueFunctionalElement = {
    parentId: -1,
    type: FUNCTIONAL_ELEMENT_TYPE.VALUE,
    id: -1,
    xmlId: '',
    label: '',
    value: '',
    disabledNACheckbox: false,
    controllingCheckpoint: '',
    disabled: false,
    contentLoadedFromXml: false,
    controllingOption: undefined,
};

export const initialValueUnitState: ValueFunctionalElement = {
    parentId: -1,
    type: FUNCTIONAL_ELEMENT_TYPE.VALUE_UNIT,
    id: -1,
    xmlId: '',
    label: '',
    value: '',
    disabledNACheckbox: false,
    controllingCheckpoint: '',
    disabled: false,
    contentLoadedFromXml: false,
    controllingOption: undefined,
};

export function isValue(f: FunctionalElement): f is ValueFunctionalElement {
    return f.type === FUNCTIONAL_ELEMENT_TYPE.VALUE || f.type === FUNCTIONAL_ELEMENT_TYPE.VALUE_UNIT;
}

export enum FUNCTION_LIMIT_TYPE {
    TwoDigitsBeforeDecimal = '2',
    TwoDigitsBeforeAndAfterDecimal = '2.2',
    ThreeDigitsBeforeDecimal = '3',
    ThreeDigitsBeforeAndAfterDecimal = '3.3',
}

export enum FUNCTION_LIMIT_RETURN_TYPE {
    TwoDigitsInteger = 'e.g. 10',
    TwoDigitsDecimal = 'e.g. 10.10',
    ThreeDigitsInteger = 'e.g. 101',
    ThreeDigitsDecimal = 'e.g. 101.101',
}
